// 载荷设置
export default {
    loadSetting: '载荷设置',
    thrower: '抛放器',
    searchlight: '探照灯',
    pager: '喊话器',
    descentRetarder: '缓降器',
    loadType: '{0}类型',
    hangPoint: '挂点',
    color: '颜色',
    default: '默认',
    blue: '蓝色',
    yellow: '黄色',
    grey: '灰色',
    purple: '紫色',
    name: '名字',
    addPlaylist: '添加至播放列表',
    device: '设备',
    PTZCamera: '云台相机',
    directShouting: '直接喊话',
    audioPlayback: '音频播放',
    playlist: '播放列表',
    previousSong: '上一曲',
    next: '下一曲',
    implement: '执行',
    stop: '停止',
    singlesPlaying: '单曲播放',
    singleTuneCirculation: '单曲循环',
    sequentialPlay: '顺序播放',
    listLoop: '列表循环',
    loopPlayback: '循环播放',
    open: '打开',
    close: '关闭',
    meanwhile: '同时',
    successively: '依次',
    interval: '间隔',
    abnormalCommunication: '通信异常',
    stow: '收起',
    putDown: '放下',
    PTZLoad: '云台载荷',
    PTZSetting: '云台设置',
    camera: '相机',
    PTZManufacturer: '云台厂商',
    PTZType: '云台型号',
    PTZModel: '云台模式',
    courseLock: '航向锁定',
    followMode: '跟随模式',
    centerCross: '中心十字',
    style: '样式{0}',
    PTZCalibration: '云台校准',
    startCalibration: '开始校准',
    imagingMode: '成像模式',
    videoQuality: '视频质量',
    electronicAntiShake: '电子防抖',
    infraredStyle: '红外样式',
    day: '白天',
    night: '夜晚',
    ordinary: '普通',
    difference: '差',
    extremelyLow: '极低',
    low: '低',
    secondary: '中',
    high: '高',
    veryHigh: '极高',
    turnOffAntiShake: '关闭防抖',
    enableElectronicAntiShake: '开启电子防抖',
    turnOnOpticalAntiShake: '开启光学防抖',
    blackFever: '黑热',
    whiteFever: '白热',
    ferruginousRed: '铁红',
    rainbow: '彩虹',
    lava: '熔岩',
    rainbowEnhancement: '彩虹增强',
    moltenMetal: '熔融金属',
    bluishRed: '蓝红',
    amber: '琥珀',
    tip_err1: '音频格式错误，请重新上传!',
    tip_err2: '音频大小不能超过 10MB!',
    tip_err3: '文件名最多10个字符，请修改之后重新上传!',
    tip_err4: '请选择需要播放的音频',
    tip_err5: '文件名只能包含中文、英文和数字!',
}